import { useState } from "react";

export function Contact() {
  const [status, setStatus] = useState<string | null>(null);

  async function submit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    const payload = Object.fromEntries(fd.entries());
    setStatus("Sending...");
    const res = await fetch("/api/inquiries", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    const data: unknown = await res.json();
    const message =
      typeof data === "object" &&
      data !== null &&
      "message" in data &&
      typeof (data as { message?: unknown }).message === "string"
        ? (data as { message: string }).message
        : undefined;
    setStatus(res.ok ? "Thank you — we’ll reply shortly." : message || "Something went wrong");
    if (res.ok) e.currentTarget.reset();
  }

  return (
    <div className="max-w-3xl mx-auto container-px py-14">
      <header className="mb-8">
        <h1 className="text-3xl md:text-4xl display">Contact</h1>
        <p className="text-foreground/70 mt-3">For commissions, wholesale, or studio visits.</p>
      </header>
      <form onSubmit={submit} className="space-y-4 rounded-xl border border-border bg-card p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm mb-1">Name</label>
            <input
              name="name"
              required
              className="w-full rounded-md border border-input bg-background px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input
              type="email"
              name="email"
              required
              className="w-full rounded-md border border-input bg-background px-3 py-2"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm mb-1">Message</label>
          <textarea
            name="message"
            rows={5}
            required
            className="w-full rounded-md border border-input bg-background px-3 py-2"
          />
        </div>
        <button className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground px-4 py-2 text-sm hover:opacity-90 transition">
          Send Inquiry
        </button>
        {status && <p className="text-xs text-foreground/70">{status}</p>}
      </form>

      <div className="mt-8 text-sm text-foreground/70">
        <p>Mano Studio · Bangkok · Open by appointment</p>
      </div>
    </div>
  );
}
